import { Component, EventEmitter, Input, Output } from '@angular/core';

export type DsStatusTone =
  | 'success'
  | 'warning'
  | 'danger'
  | 'new'
  | 'sent'
  | 'quoted'
  | 'contacted'
  | 'dispatch'
  | 'default';

@Component({
  selector: 'app-ds-status-badge',
  standalone: false,
  template: `
    <span class="ds-status-badge" [ngClass]="'ds-status-' + resolvedTone">
      {{ label || status || '—' }}
    </span>
  `,
})
export class DsStatusBadge {
  @Input() status: string | null | undefined = '';
  @Input() label: string | null | undefined;
  @Input() tone: DsStatusTone | '' = '';

  get resolvedTone(): DsStatusTone {
    if (this.tone) {
      return this.tone;
    }
    const s = (this.status || '').toLowerCase();
    if (!s) return 'default';
    if (s.includes('inactive')) return 'default';
    if (s.includes('fail') || s.includes('reject')) return 'danger';
    if (s.includes('success') || s.includes('deliver') || s.includes('approv') || s.includes('interest') || s === 'active') {
      return 'success';
    }
    if (s.includes('transact') || s.includes('process') || s.includes('validat') || s.includes('cargo') || s.includes('review')) {
      return 'warning';
    }
    if (s.includes('dispatch')) return 'dispatch';
    if (s.includes('contact')) return 'contacted';
    if (s.includes('quoted') || s.includes('transit') || s.includes('disburs')) return 'quoted';
    if (s.includes('sent') || s.includes('confirm') || s.includes('applied')) return 'sent';
    if (s.includes('new')) return 'new';
    return 'default';
  }
}
